import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const BankingCardFilledIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				stroke="transparent"
				d="M3.9 4C2.57625 4 1.5 5.07625 1.5 6.4V7.6H23.1V6.4C23.1 5.07625 22.0238 4 20.7 4H3.9ZM23.1 10.2H1.5V17.4C1.5 18.7237 2.57625 19.8 3.9 19.8H20.7C22.0238 19.8 23.1 18.7237 23.1 17.4V10.2ZM5.7 15H8.1C8.43 15 8.7 15.27 8.7 15.6C8.7 15.93 8.43 16.2 8.1 16.2H5.7C5.37 16.2 5.1 15.93 5.1 15.6C5.1 15.27 5.37 15 5.7 15ZM9.9 15.6C9.9 15.27 10.17 15 10.5 15H15.3C15.63 15 15.9 15.27 15.9 15.6C15.9 15.93 15.63 16.2 15.3 16.2H10.5C10.17 16.2 9.9 15.93 9.9 15.6Z"
			/>
		</>
	),
});
